import { createAxios } from '../../lib/axiosFactory';
import { errorParser } from '../../lib/response/errorParser';
import { ActionResponse } from '../../lib/interfaces/actionResponse';

export const actions = {
  async updateUser(context: any, { payload }: any): Promise<ActionResponse> {
    try {
      const response: any = await createAxios().patch(
        '/backend/mobiz-admin-users-update',
        {
          data: {
            type: 'users',
            attributes: payload
          }
        }
      );

      return { body: response.data.data, success: true, errors: {} };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: undefined
      };
    }
  }
};
